import { FadeIn, FadeInStagger } from '@/components/ui/animation/faideIn'
import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils/helpers'
import Link from 'next/link'
import { FiArrowUpRight } from 'react-icons/fi'

export default function CTANewEvents() {
  return (
    <div className="max-w-7xl mx-auto lg:px-8 mb-24 mt-10 w-full">
      <FadeIn className="mainpartner py-16 px-6 rounded-xl">
        <FadeInStagger faster>
          <FadeIn className="flex justify-center">
            <p
              className="font-semibold text-[48px] text-center lg:w-[765px]
             text-white text-5xl   leading-[60px]"
            >
              Enlist today and champion tomorrow's innovations.
            </p>
          </FadeIn>
          <FadeIn className="flex justify-center mt-4">
            <p
              className="text-[20px] font-normal leading-[30px]  lg: w-[768px] 
            text-center text-white text-xl"
            >
              Seize this unparalleled opportunity to shape the future. Your
              investment today has the power to foster tomorrow's breakthroughs.
            </p>
          </FadeIn>
          <FadeIn className="flex flex-col justify-center gap-4 mt-10 md:flex-row">
            <a
              href="mailto:zee@aiforge.org?subject=Become a Speaker"
              className={cn(
                buttonVariants({ size: '2xl', variant: 'secondary' }),
                'border-white/20 ',
              )}
            >
              Become a Speaker
              <FiArrowUpRight className="text-white text-2xl leading-7 ml-3" />
            </a>

            <a
              href="mailto:zee@aiforge.org?subject=Sponsor an Event"
              className={cn(
                buttonVariants({ size: '2xl', variant: 'secondary' }),
                'border-[#155EEF] px-8 md:w-[281px]',
              )}
            >
              Sponsor an Event
              <FiArrowUpRight className="text-white text-2xl leading-7 ml-3" />
            </a>
          </FadeIn>
        </FadeInStagger>
      </FadeIn>
    </div>
  )
}
